import React from 'react';
import { Col, Descriptions, Row, Tag } from 'antd';
import moment from 'moment';
import { formatCurrency } from 'util/formatters';
import display from 'constants/display';
import { BsCheck2Square } from 'react-icons/bs';
import useSubscription from 'core/hooks/useSubscription';
import {
  ACTIVATED,
  CANCELED,
  CREATED,
  EXPIRED,
  INTRIAL,
  SUSPENDED
} from 'constants/types';
import CustomScrollbars from './CustomScrollbars';

const colors = {
  [CREATED]: 'blue ',
  [ACTIVATED]: 'green ',
  [CANCELED]: 'grey',
  [SUSPENDED]: 'red',
  [EXPIRED]: 'orange ',
  [INTRIAL]: 'purple'
};

const PlanDetail = ({ subscription }) => {
  const { expiresTrialMessage } = useSubscription();
  const { plan } = subscription;

  const frequency =
    plan != null ? (plan.frequency === 'monthly' ? 'MÊS' : 'ANO') : null;
  const isTrial = subscription.status === INTRIAL;

  const getSingularOrPlural = (singularText, isPlural) => {
    if (singularText === 'profissional' && isPlural) {
      return 'profissionais';
    }

    if (singularText === 'Licença' && isPlural) {
      return 'licenças';
    }

    return singularText;
  };

  const getTitle = () => {
    const planName = plan?.name ?? 'Licença';

    if (subscription?.numberOfProfessionals > 0) {
      let number = subscription?.numberOfProfessionals;

      if (subscription.numberOfPaidProfessionals > 0) {
        number = subscription.numberOfPaidProfessionals;
      }

      return number === 1
        ? `${planName} (1 profissional)`
        : `${planName}  (${number} profissionais)`;
    }

    if (subscription?.numberOfLicenses > 0) {
      return subscription?.numberOfLicense === 1
        ? `${planName} (1 licença)`
        : `${planName} (${subscription?.numberOfLicenses} licenças)`;
    }

    return plan?.name;
  };

  return (
    <Descriptions bordered column={1}>
      <Descriptions.Item label="Plano">{getTitle()}</Descriptions.Item>
      <Descriptions.Item label="Valor">
        {subscription.amount === 0 ? (
          'Bonificado'
        ) : (
          <div>{`${formatCurrency(subscription.amount)} / ${frequency}`}</div>
        )}
      </Descriptions.Item>
      <Descriptions.Item label="Situação">
        <Row>
          <Col>
            <Tag color={colors[subscription.status]}>
              {display[subscription.status]}
            </Tag>
            {subscription.numberOfFreeProfessionals > 0 ? (
              <span className="gx-text-grey">
                {`+ Licença parceiro (${
                  subscription.numberOfFreeProfessionals
                } ${getSingularOrPlural(
                  'profissional',
                  subscription.numberOfFreeProfessionals > 1
                )})`}
              </span>
            ) : null}
          </Col>
          <Col>
            {isTrial ? (
              <span className="gx-text-red gx-fs-sm">
                {expiresTrialMessage}
              </span>
            ) : null}
          </Col>
        </Row>
      </Descriptions.Item>
      {subscription.hasLicense ? (
        <Descriptions.Item label="Parceiro">
          <Row>
            <Col>{subscription?.partnershipName}</Col>
          </Row>
        </Descriptions.Item>
      ) : null}
      <Descriptions.Item label="Recursos">
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          {plan?.features.map((feature, index) => (
            <div key={feature.id} className="gx-flex-row gx-align-items-center">
              <BsCheck2Square className="gx-mr-2" />
              <span>{feature.description}</span>
            </div>
          ))}
        </CustomScrollbars>
      </Descriptions.Item>
    </Descriptions>
  );
};

export default PlanDetail;
